module.exports = __webpack_public_path__ + "img/avateAi.f55d0e08.png";